/**
 * Tasteful "coming in a later task" placeholder (P1-T11).
 * Used for routes whose screens land in P1-T12+: template detail, editor,
 * result, paywall. Keeps deep links working without dead ends.
 */

export interface PlaceholderSpec {
  title: string;
  taskId: string;
  copy: string;
  /** Optional extra HTML (e.g. contextual details like the template slug). */
  detail?: string;
}

export function placeholderHtml(spec: PlaceholderSpec): string {
  return `
    <div class="stack placeholder">
      <h1 class="page-title">${escapeHtml(spec.title)}</h1>
      ${spec.detail ? `<p class="muted">${escapeHtml(spec.detail)}</p>` : ''}
      <div class="empty">
        <div class="empty-icon">◌</div>
        <p class="muted" style="max-width: 280px;">${escapeHtml(spec.copy)}</p>
        <p class="muted" style="font-size: var(--fs-xs);">Arrives in ${escapeHtml(spec.taskId)}</p>
      </div>
      <a class="btn btn-secondary btn-block" href="#/home">Back to Home</a>
    </div>
  `;
}

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
